import Vue from 'vue';
import ToastComponent from '../../components/toast';

let ToastConstructor = Vue.extend(ToastComponent);

let ToastInstance;

const Toast = properties => {
  if(ToastInstance){return}
  ToastInstance = new ToastConstructor();

  ToastInstance.$mount();

  document.body.appendChild(ToastInstance.$el);

  ToastInstance.visible = true;
  ToastInstance.message = properties.message;
  Vue.nextTick(() => {
    ToastInstance.timer = setTimeout(() => {
      ToastInstance.close();
      ToastInstance=null;
    }, properties.duration || 2000)
  })
}

export default Toast;





// WEBPACK FOOTER //
// ./src/plugins/toast/index.js